import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { NodeDetailsDTO } from './node-details.dto';

@Injectable()
export class EnvironmentService {
  private nodeDetails: NodeDetailsDTO;

  constructor(private http: HttpClient) {}

  public getNodeInfoObs(): Observable<NodeDetailsDTO> {
    return this.http.post<NodeDetailsDTO>('/details', null).pipe(tap((d) => (this.nodeDetails = d)));
  }

  public getNodeInfo() {
    return this.nodeDetails;
  }
}
